import { useMemo } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table/custom-header';
import type { FilterState } from '@interxfi/table-config/filter';
import { IxcMfrecoV1PositionDayQueryServicePositionDayListFilterableFields } from '@interxfi/types';
import { PageTabRail } from '../../../../../../../../../../../../../components/page-tab-rail/page-tab-rail';
import { TabbedNavigationGroup } from '../../../../../../../../../../../../../components/router/router-tabbed-navigation';
import { MfRecoPositionDaysTable } from '../../../../../../../../../../../../../features/mutual-funds/reconciliation/position-day/mfreco-position-days-table';
import { getPageHead } from '../../../../../../../../../../../../../util/routing/meta';

export const Route = createFileRoute(
  '/_app/_clearing-core/_clearing-required/clearing/operations/_operations/mutualfunds/reconciliation/position-day/_position-day/$venue/$date/',
)({
  head: () => getPageHead('Mutual Funds Position Days'),
  component: MfRecoVenueDatePositionDaysList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  return (
    <PageTabRail
      actions={
        <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
          {filter}
        </HorizontalStack>
      }
      group={TabbedNavigationGroup.ClearingOperationsMutualfunds}
    />
  );
}

function MfRecoVenueDatePositionDaysList() {
  const { date, venue } = Route.useParams();

  const fixedFilters: FilterState<IxcMfrecoV1PositionDayQueryServicePositionDayListFilterableFields> = useMemo(
    () => [
      {
        type: {
          filters: [
            { id: IxcMfrecoV1PositionDayQueryServicePositionDayListFilterableFields.Venue, value: { exact: venue } },
            { id: IxcMfrecoV1PositionDayQueryServicePositionDayListFilterableFields.Date, value: { exact: date } },
          ],
        },
      },
    ],
    [date, venue],
  );

  return (
    <PageLayout>
      <PageLayout.Section>
        <MfRecoPositionDaysTable fixedFilters={fixedFilters} HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
